import { goalsGetters } from '@frontend/helpers/store/getters'

export default {
  ...goalsGetters,
}
